<style>
.center {
  margin: 20px 0 0 20px;
}
</style>
<template>
  <ut-form :label-width="200">
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 监控名称：
      </template>
      <ut-input placeholder="请描述您的监控项" v-model="name" :style="{width:'500px'}"></ut-input>
      <ut-alert type="warn" :style="{width:'500px'}">如果当前监控项作为某个服务的存活监控项,那么命名格式建议为:[XXXX服务存活监控-IP]</ut-alert>
    </ut-form-item>

    <!-- 引入的公共组件开始 -->
    <formAdd v-model="formData" v-if="!second"></formAdd>
    <!-- 引用的公共组件结束 -->

    <!-- <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 目标监控URL：
      </template>
      <ut-input class="demo-input" v-model="url" :style="{width:'500px'}">
        <template slot="addonBefore" :style="{width:'100px'}">
          <ut-select v-model="requestType" class="demo-input-select" :style="{width:'100px'}">
            <ut-option
              v-for="item in reqTypeData"
              :value="item.value"
              :key="item.value"
              :label="item.label"
            ></ut-option>
          </ut-select>
        </template>
      </ut-input>
    </ut-form-item> -->
    <!-- <ut-form-item label="请求参数"  v-show="postInputShow" >
      <ut-input v-model="reqContent" :style="{width:'500px'}"></ut-input>
    </ut-form-item> -->
    <!-- <ut-form-item v-show="postInputShow">
      <template slot="label">
        <span style="color:red">*</span> content-type
      </template>
      <ut-select v-model="contentTypeValue" class="demo-input-select" :style="{width:'150px'}">
        <ut-option
          v-for="item in contentType"
          :value="item.value"
          :key="item.value"
          :label="item.label"
        ></ut-option>
      </ut-select>
    </ut-form-item> -->

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 测试URL探测：
      </template>
      <ut-button type="primary" @click="checkUrl">添加规则</ut-button>
      <ut-button type="primary" @click="checkRules" :disabled="isDisable">验证规则</ut-button>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 请选择应用
      </template>
      <ut-select v-model="selected1" filterable :style="{width:'500px'}" :filter-method='filter'>
        <ut-option
          v-for="item in appSearchOptions||appOptions"
          :value="item.appId"
          :key="item.appId"
          :label="item.appId"
        ></ut-option>
      </ut-select>
    </ut-form-item>

    <ut-form-item label>
      <template slot="label">
        <span style="color:red">*</span>报警策略
      </template>
      <ut-select v-model="selected2" filterable :style="{width:'500px'}">
        <ut-option v-for="item in policyOptions" :value="item.id" :key="item.id" :label="item.name"></ut-option>
      </ut-select>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 是否生效：
      </template>
      <ut-radio-group v-model="isEffect">
        <ut-radio-button value="true">生效</ut-radio-button>
        <ut-radio-button value="false">失效</ut-radio-button>
      </ut-radio-group>
    </ut-form-item>
    <ut-form-item>
      <template slot="label">校验规则</template>
      <ut-input
        type="textarea"
        v-model="modeValue"
        :autosize="{ minRows: 6, maxRows: 16 }"
        :style="{width:'500px'}"
      ></ut-input>
    </ut-form-item>
    <ut-form-item>
      <ut-button type="primary" @click="submit">立即创建</ut-button>
      <ut-button @click="goBack">取消</ut-button>
    </ut-form-item>

    <ut-drawer v-model="second" title="URL验证返回结果" :modal="false" width="840">
      <ut-form :label-width="150">
        <!-- 引入的公共组件 -->
        <formAdd v-model="formData" v-if="second"></formAdd>
        <!-- <ut-form-item label="URL地址">
          <ut-input v-model="url" class="demo-input">
            <template slot="addonBefore">
              <ut-select v-model="requestType" class="demo-input-select" :style="{width:'100px'}">
                <ut-option
                  v-for="item in reqTypeData"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></ut-option>
              </ut-select>
            </template>
          </ut-input>
        </ut-form-item> -->
        <!-- <ut-form-item label="请求参数" v-show="postInputShow">
          <ut-input v-model="reqContent" v-show="postInputShow"></ut-input>
        </ut-form-item> -->
        <!-- <ut-form-item label="content-type" v-show="postInputShow">
          <ut-select v-model="contentTypeValue" class="demo-input-select" :style="{width:'150px'}">
            <ut-option
              v-for="item in contentType"
              :value="item.value"
              :key="item.value"
              :label="item.label"
            ></ut-option>
          </ut-select>
        </ut-form-item> -->
      </ut-form>
      <div class="demo-drawer-footer" slot='footer'>
          <ut-button type="success" @click.native="checkRules">验证规则</ut-button>&nbsp;
          <ut-button type="success" @click.native="viewCondition">确认</ut-button>&nbsp;
          <ut-button type="success" @click.native="checkUrl">模拟数据</ut-button>&nbsp;
        </div>
      <template>
        <ut-tabs @change="changeTab" :value="2">
          <ut-tab-pane label="增加规则" :name="2">
            <div class="app-container">
              <ut-form inline class="left">
                <ut-form-item>
                  <ut-alert
                    type="warn"
                    :style="{width:'700px'}"
                  >第一步、增加跟节点，OR则全部条件有一条符合则成功返回，AND则全部条件都符合则返回成功。</ut-alert>
                  <ut-button type="primary" @click="addOr">增加OR节点</ut-button>
                  <ut-button type="primary" @click="addAnd">增加AND节点</ut-button>
                </ut-form-item>
              </ut-form>
              <ut-form inline class="left">
                <ut-alert
                  type="warn"
                  :style="{width:'700px'}"
                >第二步、首先选择节点，增加规则，KEY已经被系统自动生成，按照JSON转换YAML的方式进行选择。</ut-alert>
                <ut-form-item>
                  <ut-select
                    v-model="selected3"
                    filterable
                    :style="{width:'150px'}"
                    placeholder="KEY"
                  >
                    <ut-option
                      v-for="item in yamlOptions"
                      :value="item.id"
                      :key="item.id"
                      :label="item.name"
                    ></ut-option>
                  </ut-select>
                </ut-form-item>
                <ut-form-item>
                  <ut-select
                    v-model="selected4"
                    filterable
                    :style="{width:'100px'}"
                    placeholder="操作符"
                  >
                    <ut-option
                      v-for="item in operates"
                      :value="item.value"
                      :label="item.label"
                      :key="item.value"
                    ></ut-option>
                  </ut-select>
                </ut-form-item>
                <ut-form-item>
                  <ut-input
                    placeholder="值"
                    v-model="checkValue"
                    :style="{width:'100px'}"
                    v-if="selected4 < '6' || selected4 > '9'"
                  ></ut-input>
                </ut-form-item>
                <ut-form-item>
                  <ut-button type="primary" @click="addCheckUrl">添加</ut-button>
                  <ut-button type="primary" @click="delCheckUrl">删除</ut-button>
                </ut-form-item>
              </ut-form>
            </div>
            <div>
              <ut-form>
                <ut-form-item>
                  <ut-input v-model="searchWords" placeholder="搜索"></ut-input>
                  <ut-tree
                    :query="searchWords"
                    :data="baseData3"
                    multiple
                    label-key="title"
                    value-key="id"
                    v-model="selected5"
                    expand-all
                    @node-click="changeValue"
                  ></ut-tree>
                </ut-form-item>
              </ut-form>
            </div>
          </ut-tab-pane>
          <ut-tab-pane label="KEY-VALUE" :name="1">
            <ut-alert :autosize="{ minRows: 6, maxRows: 16 }">
              <span v-html="yaml"></span>
            </ut-alert>
          </ut-tab-pane>
          <ut-tab-pane label="返回值" :name="0">
            <ut-alert :autosize="{ minRows: 6, maxRows: 16 }" v-model="source">{{ source}}</ut-alert>
            <!-- <ut-input type="textarea"  :autosize="{ minRows: 6, maxRows: 16 }"></ut-input> -->
          </ut-tab-pane>
        </ut-tabs>
      </template>
    </ut-drawer>
  </ut-form>
</template>

<script lang="babel">
import formAdd from '@/components/base/formAdd'
export default {
  data () {
    return {
      name: '',
      url: '',
      isDisable: false,
      isEffect: '',
      selected1: '',
      selected2: '',
      appOptions: [],
      appSearchOptions: null,
      policyOptions: [],
      second: false,
      requestType: '',
      forms: [],
      reqContent: '',
      source: '',
      selected3: [],
      selected4: [],
      yamlOptions: [],
      checkValue: '',
      searchWords: '',
      baseData3: [],
      selected5: [],
      orIndex: 0,
      andIndex: 0,
      childrenIndex: 0,
      childrenSelect: '',
      yaml: '',
      modeValue: '',
      contentTypeValue: 0,
      reqTypeData: [
        { value: 0, label: 'GET' },
        { value: 1, label: 'POST' }
      ],
      contentType: [
        { value: 0, label: 'application/json' }
      ],
      operates: [
        { value: '0', label: '大于' },
        { value: '1', label: '小于' },
        { value: '2', label: '等于' },
        { value: '3', label: '不等于' },
        { value: '4', label: '包含' },
        { value: '5', label: '不包含' },
        // {value:"6",label:"有值"},
        // {value:"7",label:"没值"},
        { value: '8', label: '为空' },
        { value: '9', label: '不为空' },
        { value: '10', label: '正则' }
      ],
      // formData数据，用于将数据传递到子组件上去，默认添加初始化一些值
      formData: {
        requestType: 0,
        postContent: '',
        querys: null,
        headers: null,
        url: '',
        user: '',
        password: ''
      }
    }
  },
  components: {
    formAdd
  },
  watch: {
    second () {
      var headersObj = {}
      var querysObj = {}
      if (this.formData.headers instanceof Array && this.formData.headers.length > 0) {
        this.formData.headers.forEach((val, index) => {
          headersObj[val.key] = val.value
        })
      } else {
        headersObj = {}
      }
      if (this.formData.querys instanceof Array && this.formData.querys.length > 0) {
        this.formData.querys.forEach((val, index) => {
          querysObj[val.key] = val.value
        })
      } else {
        querysObj = {}
      }
      let querys = JSON.stringify(querysObj)
      let headers = JSON.stringify(headersObj)
      this.formData.headers = headers
      this.formData.querys = querys
    }
  },
  computed: {
    postInputShow () {
      if (this.requestType == '1') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    filter (val) {
      const data = []
      this.appOptions.map(item => {
          if (item.appId.toLowerCase().indexOf(val) !== -1 || item.appName.toLowerCase().indexOf(val) !== -1) {
            data.push(item)
          }
      })
      if (data.length) {
        this.appSearchOptions = data;
      } else {
        this.appSearchOptions = [];
      }
    },
    select4Change (v2) {
      // console.log(v2)
    },
    changeTab (tab) {
    },
    addItem () {
      this.forms.push({
        git: ''
      })
    },
    removeItem (idx) {
      this.forms.splice(idx, 1)
    },
    submit () {
      var name = this.name
      var url = this.formData.url
      var isEffect = this.isEffect
      var appId = this.selected1
      var alarmPolicyId = this.selected2
      var requestType = this.formData.requestType
      // var postContent = this.formData.postContent

      var headersObj = {}
      var querysObj = {}
      var postContent
      if (requestType === 0 || requestType === 2) {
        postContent = ''
      } else {
        postContent = this.formData.postContent
      }

      if (this.formData.headers instanceof Array && this.formData.headers.length > 0) {
        this.formData.headers.forEach((val, index) => {
          headersObj[val.key] = val.value
        })
      } else {
        headersObj = {}
      }
      if (this.formData.querys instanceof Array && this.formData.querys.length > 0) {
        this.formData.querys.forEach((val, index) => {
          querysObj[val.key] = val.value
        })
      } else {
        querysObj = {}
      }
      let querys = JSON.stringify(querysObj)
      let headers = JSON.stringify(headersObj)

      if (name == '') {
        this.$message.error('监控名称不能为空')
        return false
      }
      if (url == '') {
        this.$message.error('url 不能为空')
        return false
      }

      if (isEffect == '') {
        this.$message.error('请选择是否生效')
        return false
      }
      if (this.selected1 == '') {
        this.$message.error('应用不能为空')
        return false
      }
      if (this.selected2 == '') {
        this.$message.error('报警策略不能为空')
        return false
      }
      if (requestType === '') {
        this.$message.error('请求类型不能为空')
        return false
      }
      var sendData = {}
      sendData.name = name
      sendData.appId = appId
      sendData.alarmPolicyId = alarmPolicyId
      sendData.url = url
      sendData.isEffect = isEffect
      sendData.requestType = requestType

      // sendData.postContent = postContent
      if (postContent.trim().length !== 0) {
        var parsed
        try {
          parsed = JSON.parse(postContent)
          sendData.postContent = JSON.stringify(parsed)
        } catch (err) {
          this.$message.error('非法的body参数')
          return
        }
      } else {
        sendData.postContent = ''
      }

      sendData.headers = headers
      sendData.querys = querys
      sendData.user = this.formData.user
      sendData.password = this.formData.password

      sendData.ruleTxt = JSON.stringify(this.baseData3[0])
      sendData.bizType = 1
      var rootBase = this.baseData3[0]
      var jsonValue = []
      // console.log(rootBase)
      if (rootBase !== undefined) {
        rootBase.children.forEach((list) => {
          var classA = { group: rootBase.id }
          classA.rules = []
          if (list.type === 3) {
            // console.log('classA.rules.push : ' + list.jsonValue)
            classA.rules.push(list.jsonValue)
          } else {
            if (list.children != undefined && list.children.length > 0) {
              var classB = { group: list.id }
              classB.rules = []
              list.children.forEach((children) => {
                if (children.type === 3) { classB.rules.push(children.jsonValue) }
              })
              if (classB.rules.length > 0) { jsonValue.push(classB) }
            }
          }
          if (classA.rules.length > 0) { jsonValue.push(classA) }
        })
        var rootJson = {}
        if (this.baseData3[0].title === 'or') {
          rootJson = { group: 'or' }
          rootJson.groupRuleVos = jsonValue
        } else {
          rootJson = { group: 'and' }
          rootJson.groupRuleVos = jsonValue
        }
        sendData.groupRules = rootJson
      }

      // console.log(sendData)
      this.$http({
        method: 'post',
        url: 'urls/add.htm',
        data: JSON.stringify(sendData)
      })
        .then(response => {
          // 这里使用了ES6的语法
          // console.log(response) // 请求成功返回的数据
          if (response.data.code == 0) {
            this.$message.success('添加成功')
            this.$router.push({ path: '/urls_rule' })
          } else {
            this.$message.error(response.data.message)
            return false
          }
        })
        .catch(error => {
          // console.log(error) // 请求失败返回的数据
          this.$message.error(error) // 请求失败返回的数据
        })
    },
    addOr () {
      this.orIndex++
      var orRoot = {}
      orRoot.id = 'or' + this.orIndex
      orRoot.title = 'or'
      orRoot.children = []
      orRoot.type = 1
      if (this.childrenSelect == '' && this.baseData3.length > 0) {
        this.$message.error('根节点不能再添加or')
        return false
      }
      var isSuccess = true
      if (this.childrenSelect == '' && this.baseData3.length === 0) {
        isSuccess = false
        this.baseData3.push(orRoot)
      }
      this.baseData3.forEach((temp) => {
        if (temp.id === this.childrenSelect) {
          temp.children.push(orRoot)
          isSuccess = false
          orRoot.type = 0
        }
      })
      if (isSuccess) {
        this.$message.error('叶子节点不能大于两级')
        return false
      }
    },
    checkRules () {
      var name = this.name
      var url = this.formData.url
      var isEffect = this.isEffect
      var appId = this.selected1
      var alarmPolicyId = this.selected2
      var requestType = this.formData.requestType
      // var postContent = this.reqContent
      var postContent
      if (this.formData.requestType === 0 || this.formData.requestType === 2) {
        postContent = ''
      } else {
        postContent = this.formData.postContent
      }

      if (url == '') {
        this.$message.error('url 不能为空')
        return false
      }

      if (requestType === '') {
        this.$message.error('请求类型不能为空')
        return false
      }

      var headersObj = {}
      var querysObj = {}
      if (this.formData.headers instanceof Array && this.formData.headers.length > 0) {
        this.formData.headers.forEach((val, index) => {
          headersObj[val.key] = val.value
        })
      } else {
        headersObj = {}
      }
      if (this.formData.querys instanceof Array && this.formData.querys.length > 0) {
        this.formData.querys.forEach((val, index) => {
          querysObj[val.key] = val.value
        })
      } else {
        querysObj = {}
      }

      let querys = JSON.stringify(querysObj)
      let headers = JSON.stringify(headersObj)

      var sendData = {}
      sendData.name = name
      sendData.appId = appId
      sendData.alarmPolicyId = alarmPolicyId
      sendData.urlPath = url
      sendData.isEffect = isEffect
      sendData.requestType = requestType

      if (postContent.trim().length !== 0) {
        var parsed
        try {
          parsed = JSON.parse(postContent)
          sendData.content = JSON.stringify(parsed)
        } catch (err) {
          this.$message.error('非法的body参数')
          return
        }
      } else {
        sendData.content = ''
      }

      // sendData.content = postContent

      sendData.headers = headers
      sendData.querys = querys
      sendData.user = this.formData.user
      sendData.password = this.formData.password

      var rootBase = this.baseData3[0]
      var jsonValue = []
      if (rootBase !== undefined) {
        rootBase.children.forEach((list) => {
          var classA = { group: rootBase.id }
          classA.rules = []
          if (list.type === 3) {
            // console.log('classA.rules.push : ' + list.jsonValue)
            classA.rules.push(list.jsonValue)
          } else {
            if (list.children != undefined && list.children.length > 0) {
              var classB = { group: list.id }
              classB.rules = []
              list.children.forEach((children) => {
                if (children.type === 3) { classB.rules.push(children.jsonValue) }
              })
              if (classB.rules.length > 0) { jsonValue.push(classB) }
            }
          }
          // console.log(classA)
          if (classA.rules.length > 0) { jsonValue.push(classA) }
        })
        var rootJson = {}
        if (this.baseData3[0].title === 'or') {
          rootJson = { group: 'or' }
          rootJson.groupRuleVos = jsonValue
        } else {
          rootJson = { group: 'and' }
          rootJson.groupRuleVos = jsonValue
        }
        sendData.groupRules = rootJson
      }

      this.$http({
        method: 'post',
        url: 'urls/ruleTest.htm',
        data: JSON.stringify(sendData)
      })
        .then(response => {
          // 这里使用了ES6的语法
          // console.log(response) // 请求成功返回的数据
          if (response.data.code == 0) {
            this.$message.success('验证成功')
          } else {
            this.$message.error(response.data.message)
            return false
          }
        })
        .catch(error => {
          // console.log(error) // 请求失败返回的数据
          this.$message.error(error)
        })
    },
    getTreeJsonValue (thisObj, obj) {
      var relationValue = ''
      var list = []
      if (thisObj !== undefined) {
        if (thisObj.children !== undefined && thisObj.children.length > 0) {
          relationValue = thisObj.title
          thisObj.children.forEach((temp) => {
            if (temp.type === 3) {
              list.push(temp.jsonValue)
            } else {
              // 递归获取
              this.getTreeJsonValue(temp, obj)
            }
          })
        }
      }
      var appendNode = {}
      if (relationValue === 'and') {
        appendNode = { and: list }
      }
      if (relationValue === 'or') {
        appendNode = { or: list }
      }
      if (obj.children === undefined || obj.children.length === 0) {
        obj.children = []
      }
      obj.children.push(appendNode)
      // console.log('递归返回的json : ' + JSON.stringify(obj.children))
      return obj
    },
    addAnd () {
      this.andIndex++
      var andRoot = {}
      andRoot.id = 'and' + this.andIndex
      andRoot.title = 'and'
      andRoot.type = 1
      andRoot.children = []
      if (this.childrenSelect == '' && this.baseData3.length > 0) {
        this.$message.error('根节点不能再添加and')
        return false
      }
      var isSuccess = true
      if (this.childrenSelect == '' && this.baseData3.length === 0) {
        isSuccess = false
        this.baseData3.push(andRoot)
      }

      this.baseData3.forEach((temp) => {
        if (temp.id === this.childrenSelect) {
          andRoot.type = 0
          temp.children.push(andRoot)
          isSuccess = false
        }
      })
      if (isSuccess) {
        this.$message.error('叶子节点不能大于两级')
        return false
      }
    },
    changeValue (k, v) {
      // console.log(k.id + ':' + v)
      this.childrenSelect = k.id
    },
    addCheckUrl () {
      if (this.selected3 === undefined || this.selected3 === '') {
        this.$message.error('请选择Key')
        return false
      }
      if (this.selected4 === undefined || this.selected4 === '') {
        this.$message.error('请选择操作符')
        return false
      }
      if (this.selected4 < '6' || this.selected4 > '9') {
        if (this.checkValue === undefined || this.checkValue === '') {
          this.$message.error('请输入对应的值')
          return false
        }
      }
      if (this.childrenSelect === '') {
        this.$message.error('请选择根节点进行添加')
        return false
      }
      var jsonValue = {}
      jsonValue.key = this.selected3
      jsonValue.operate = this.selected4
      if (jsonValue.operate == 8 || jsonValue.operate == 9) {
        this.checkValue = ''
      }
      jsonValue.value = this.checkValue
      var children = {}
      // console.log('select4 : ' + this.selected4)
      var selected4Label = ''
      this.operates.forEach((temp) => {
        if (temp.value === this.selected4) {
          selected4Label = temp.label
        }
      })
      jsonValue.co = selected4Label
      this.childrenIndex = this.childrenIndex + 1
      children.id = this.selected3 + this.childrenIndex
      children.title = this.selected3 + ' ' + selected4Label + ' ' + this.checkValue
      children.jsonValue = jsonValue
      children.type = 3
      this.baseData3.forEach((temp) => {
        if (temp.children.length > 0) {
          temp.children.forEach((childrenTemp) => {
            if (childrenTemp.id === this.childrenSelect) {
              if (childrenTemp.type !== 3) {
                childrenTemp.children.push(children)
              } else {
                this.$message.error('不能在规则下面创建规则')
              }
            }
          })
        }
        if (temp.id === this.childrenSelect) {
          temp.children.push(children)
        }
      })
    },
    delCheckUrl () {
      // console.log('this.childrenSelect' + this.childrenSelect)
      if (this.childrenSelect === '') {
        this.$message.error('请选择根节点进行删除')
        return false
      }
      // console.log(this.baseData3)

      if (this.baseData3[0].id === this.childrenSelect) {
        // console.log(this.baseData3[0].id + ' : ' + this.childrenSelect)
        this.baseData3 = []
        this.childrenSelect = ''
        return false
      }

      this.baseData3[0].children.forEach((temp, index) => {
        if (temp.id === this.childrenSelect) {
          this.baseData3[0].children.splice(index, 1)
          this.childrenSelect = ''
        }
        if (temp.children != undefined && temp.children.length > 0) {
          temp.children.forEach((temp1, index1) => {
            if (temp1.id === this.childrenSelect) {
              // console.log(this.baseData3[0].children)
              // console.log('下标:' + index + ' chiildren : ' + this.baseData3[0].children[index] + ' : ' + index1)
              this.baseData3[0].children[index].children.splice(index1, 1)
              this.childrenSelect = ''
            }
          })
        }
      })
    },
    checkUrl () {
      this.second = true
      this.yamlOptions = []
      var sendData = {}
      sendData.requestType = this.formData.requestType
      var postContent
      if (this.formData.requestType === 0 || this.formData.requestType === 2) {
        postContent = ''
      } else {
        postContent = this.formData.postContent
      }
      var headersObj = {}
      var querysObj = {}
      if (this.formData.headers instanceof Array && this.formData.headers.length > 0) {
        this.formData.headers.forEach((val, index) => {
          headersObj[val.key] = val.value
        })
      } else {
        headersObj = {}
      }
      if (this.formData.querys instanceof Array && this.formData.querys.length > 0) {
        this.formData.querys.forEach((val, index) => {
          querysObj[val.key] = val.value
        })
      } else {
        querysObj = {}
      }
      let querys = JSON.stringify(querysObj)
      let headers = JSON.stringify(headersObj)

      if (postContent.trim().length !== 0) {
        var parsed
        try {
          parsed = JSON.parse(postContent)
          sendData.content = JSON.stringify(parsed)
        } catch (err) {
          this.$message.error('非法的body参数')
          return
        }
      } else {
        sendData.content = ''
      }

      // sendData.content = postContent
      sendData.headers = headers
      sendData.querys = querys
      sendData.user = this.formData.user
      sendData.password = this.formData.password

      // sendData.content = this.reqContent
      if (this.formData.requestType === '') {
        this.$message.error('请求类型不能为空')
        return false
      }
      if (this.formData.url == '') {
        this.$message.error('URL不能为空')
        return false
      }
      sendData.urlPath = this.formData.url
      this.$http({
        method: 'post',
        url: 'urls/checkUrl.htm',
        data: JSON.stringify(sendData)
      })
        .then(response => {
          if (response.data.code === 0) {
            this.$message.success('正确')
            var message = JSON.parse(response.data.message)
            this.source = message.yaml
            var selected3Arrar = new Array()
            var index = 0
            for (var key in message.yamlMap) {
              this.yamlOptions.push({ 'id': key })
            }
            this.yaml = this.format(message.yamlMap)
          } else {
            this.$message.error(response.data.message)
          }
          // 这里使用了ES6的语法
          // console.log(response.data.code) // 请求成功返回的数据
        })
        .catch(error => {
          this.$message.error(error) // 请求失败返回的数据
        })
    },
    viewCondition () {
      if (this.baseData3.length <= 0) {
        this.$message.error('没有增加任何规则')
        this.modeValue = ''
        this.second = false
        return false
      }
      var jsQL = ''
      var root = this.baseData3[0]
      this.second = false
      var rootIndex = 0
      root.children.forEach((children) => {
        var linkSymbol = ''
        if (root.id.indexOf('or') > -1) {
          linkSymbol = ' OR '
        }
        if (root.id.indexOf('and') > -1) {
          linkSymbol = ' AND '
        }
        // console.log(children)
        if (children.type === 3) {
          if (rootIndex === 0) {
            jsQL += children.jsonValue.key + children.jsonValue.co + children.jsonValue.value
            rootIndex++
          } else {
            jsQL += linkSymbol + children.jsonValue.key + children.jsonValue.co + children.jsonValue.value
          }
        } else {
          if (children.children.length > 0) {
            if (rootIndex > 0) {
              jsQL += linkSymbol
            }
            var twoLinkSymbol = ''
            if (children.id.indexOf('or') > -1) {
              twoLinkSymbol = ' OR '
            }
            if (children.id.indexOf('and') > -1) {
              twoLinkSymbol = ' AND '
            }
            jsQL += '('
            var index = 0
            children.children.forEach((c1) => {
              if (index === 0) {
                jsQL += c1.jsonValue.key + c1.jsonValue.co + c1.jsonValue.value
                index++
              } else {
                jsQL += twoLinkSymbol + c1.jsonValue.key + c1.jsonValue.co + c1.jsonValue.value
              }
            })
            jsQL += ')'
          }
        }
      })
      this.modeValue = jsQL
      // console.log(jsQL)
    },
    goBack () {
      this.$router.push({ path: '/urls_rule' })
    },
    format (obj) {
      var rep = '~'
      var jsonStr = JSON.stringify(obj, null, rep)
      var str = ''
      for (var i = 0; i < jsonStr.length; i++) {
        var text2 = jsonStr.charAt(i)
        if (i > 1) {
          var text = jsonStr.charAt(i - 1)
          if (rep != text && rep == text2) {
            str += '<br/>'
          }
        }
        str += text2
      }
      jsonStr = ''
      for (var i = 0; i < str.length; i++) {
        var text = str.charAt(i)
        if (rep == text) { jsonStr += '&nbsp;&nbsp;&nbsp;&nbsp;' } else {
          jsonStr += text
        }
        if (i == str.length - 2) { jsonStr += '<br/>' }
      }
      return jsonStr
    },
    test () {
      var name = this.name
      var url = this.formData.url
      var isEffect = this.isEffect
      var appId = this.selected1
      var alarmPolicyId = this.selected2

      if (url == '') {
        this.$message.error('url 不能为空')
        return false
      }

      var sendData = {}

      sendData.urlPath = url
      if (this.requestType === '') {
        this.$message.error('请选择请求方式')
        return false
      }
      sendData.requestType = this.formData.requestType

      this.isDisable = true
      this.$http({
        method: 'post',
        url: 'urls/ping.htm',
        data: sendData
      })
        .then(response => {
        // 这里使用了ES6的语法
          // console.log(response) // 请求成功返回的数据

          if (response.data.code == 200) {
            this.$message.info(response.data.message)
          } else {
            this.$message.error('连接不通')
          }
          this.isDisable = false
        })
        .catch(error => {
          this.isDisable = false
          console.log(error) // 请求失败返回的数据
          this.$message.error('连接不通')
        })
    }
  },
  created () {
    // 应用加载
    this.$http({
      method: 'post',
      url: 'apps/list.htm',
      data: '{}'
    })
      .then(response => {
        // 这里使用了ES6的语法
        // console.log(response.data.length) // 请求成功返回的数据
        this.appOptions = response.data
      })
      .catch(error => {
        // console.log(error) // 请求失败返回的数据
        this.$message.error(error)
      })
    // 报警策略加载
    this.$http({
      method: 'post',
      url: 'policys/list.htm',
      data: '{}'
    })
      .then(response => {
        // 这里使用了ES6的语法
        this.policyOptions = response.data
      })
      .catch(error => {
        // console.log(error) // 请求失败返回的数据
        this.$message.error(error)
      })
  }
}
</script>

<style lang="less">
.demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
}
.demo-input {
  .utear-input + .utear-input {
    margin-top: 15px;
  }
  .demo-input-select {
    display: block;
    margin: -10px;
    .utear-input {
      width: 100px;
      input {
        border: 0;
        background: transparent;
        color: #99a9bf;
      }
    }
  }
}
</style>
